export const hiddenNotifications = ['account_warning', 'account_blocked']
